type CustomSizeRenderingInput = {
  optionId: string;
  optionType: string;
  hasValues: boolean;
  hasCustomSizeValue: boolean;
  forceDropdownRadioOptions: boolean;
  hasCompactSingleValue: boolean;
};

/**
 * De normale `size`-route rendert de eigen-maatvelden al binnen
 * GroupedSizeSelector. Het oudere losse paneel is alleen nog nodig als die
 * selector bewust wordt overgeslagen (dropdownmodus of één compacte waarde).
 */
export function shouldRenderSeparateCustomSizePanel({
  optionId,
  optionType,
  hasValues,
  hasCustomSizeValue,
  forceDropdownRadioOptions,
  hasCompactSingleValue,
}: CustomSizeRenderingInput): boolean {
  if (optionId !== 'size' || optionType !== 'custom-size' || !hasValues || !hasCustomSizeValue) return false;
  return forceDropdownRadioOptions || hasCompactSingleValue;
}
